<template>
  <div class="ZpListToolbar">
    <v-text-field
      :value="value"
      @input="onInput"
      :placeholder="$t('search')"
      hide-details dense outlined clearable
      class="ZpListToolbar__search"
    >
      <template #prepend-inner>
        <ZpIcon name="search" :size="18" class="ZpListToolbar__searchIcon" />
      </template>
    </v-text-field>

    <div v-if="selectionCount > 0" class="ZpListToolbar__bulk">
      <span class="ZpListToolbar__count zp-tabular">
        {{ $t('selectedN', { count: selectionCount }) }}
      </span>

      <slot name="bulk-actions" :count="selectionCount" />

      <v-btn
        depressed
        small
        color="error"
        class="ZpListToolbar__btn"
        @click="$emit('bulk-delete')"
      >
        <ZpIcon name="trash-2" :size="16" class="mr-1" />
        {{ $t('deleteN', { count: selectionCount }) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListToolbar',

  props: {
    value: { type: String, default: '' },
    selectionCount: { type: Number, default: 0 },
  },

  methods: {
    onInput(value) {
      this.$emit('input', value || '');
      this.$emit('search', value || '');
    },
  },
};
</script>

<style lang="scss">
.ZpListToolbar {
  display: flex;
  align-items: center;
  gap: var(--zp-space-sm);
  flex: 1 1 auto;
  min-width: 0;
}

.ZpListToolbar__search {
  max-width: 280px;
  flex: 0 1 280px;

  .v-input__slot {
    min-height: 36px !important;
    border-radius: var(--zp-radius-md) !important;
  }

  .v-input__prepend-inner {
    margin-top: 8px !important;
    margin-right: 4px;
  }
}

.ZpListToolbar__searchIcon {
  color: var(--zp-text-tertiary);
}

.ZpListToolbar__bulk {
  display: flex;
  align-items: center;
  gap: var(--zp-space-sm);
  padding-left: var(--zp-space-sm);
  border-left: var(--zp-border-hair) solid var(--zp-border-hairline);
  margin-left: var(--zp-space-xs);
}

.ZpListToolbar__count {
  font-size: var(--zp-text-sm);
  color: var(--zp-text-secondary);
  font-weight: 600;
  white-space: nowrap;
}

.ZpListToolbar__btn {
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: var(--zp-tracking-label);
  border-radius: var(--zp-radius-md) !important;
}
</style>
